<template>
  <a :href="source" download class="attachment">
    <Icon name="ant-design:file-pdf-outlined" class="attachment__icon"/>
    <span>{{ name }}</span>
  </a>
</template>

<script lang="ts" setup>
const props = defineProps({
  src: {
    type: String as PropType<string>,
    required: true
  },
  name: {
    type: String as PropType<string>,
    required: true
  },
  extension: {
    type: String as PropType<string>,
    default: 'pdf'
  }
});

const runtimeConfig = useRuntimeConfig();
const source = computed(() => `${runtimeConfig.public.strapi.url}/uploads/${props.src}`);
</script>

<style lang="scss" setup>
.attachment {
  border: 2px solid $text;
  display: inline-flex;
  align-items: center;
  padding: 1rem 1.5rem;
  text-decoration: none;
  color: $text;
  border-radius: 0.5rem;
  transition: all 300ms ease-in-out;
  overflow-x: hidden;

  span {
    font-size: 0.9rem;
    font-weight: 600;
    flex-grow: 1;
    flex-shrink: 1;
  }

  &:hover {
    border-color: $sun;
    color: $sun;
  }
}

.attachment__icon {
  margin-right: 1rem;
  width: 1.5rem;
  height: 1.5rem;
  color: currentColor;
  flex-shrink: 0;
}
</style>
